import { createFileRoute, redirect } from "@tanstack/react-router";
import { getOrgRecordWorkspacePath } from "@/features/records/lib/get-org-record-workspace-path.util";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/records/(record)/$recordId/workspace/",
)({
	beforeLoad: ({ params }) => {
		throw redirect({
			href: getOrgRecordWorkspacePath({
				orgId: params.orgId,
				recordId: params.recordId,
				tab: "form",
			}),
		});
	},
});
